import { useSplitTestBranch } from '@api/lendingAPI/lapiHooks';
import { getCountry } from '@iwIntlProvider/CountryProvider';

export const OPEN_SHAREABLE_LINK_SPLIT_TEST =
    'uk_open_shareable_link_repeats_2026';

export const useOpenShareableLinkSplitTest = () => {
    const isUK = getCountry() === 'UK';

    const { branch } = useSplitTestBranch({
        test: OPEN_SHAREABLE_LINK_SPLIT_TEST,
        suspense: false,
        enabled: isUK
    });

    return {
        isInOpenShareableLinkSplitTest: isUK && branch === 'INCLUDE'
    };
};
